import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeatsioComponent } from './seatsio.component';
import { SeatsioAngularModule } from '@seatsio/seatsio-angular';

@NgModule({
  declarations: [
    SeatsioComponent
  ],
  imports: [
    CommonModule,
    SeatsioAngularModule,
  ],
  exports: [SeatsioComponent]
})
export class SeatsioModule { }
